var _defs, _path, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeakSensor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Leak_Sensor",
    "data-name": "Leak Sensor",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 78,
    height: 40,
    viewBox: "0 0 78 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.505,
    y1: -0.556,
    x2: 0.493,
    y2: 1.029,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.225,
    stopColor: "#00adee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.751,
    stopColor: "#0072bc"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3892",
    "data-name": "Path 3892",
    d: "M69.44,25.274c2.59-1.34,4.07-2.871,4.07-4.491,0-5.391-16.19-9.762-36.17-9.762S1.18,15.4,1.18,20.782s16.19,9.762,36.17,9.762c1.17,0,2.33-.02,3.47-.05a3.724,3.724,0,0,0-.34,1.49c0,4.421,8.4,8.012,18.76,8.012S78,36.416,78,32C78,29.175,74.59,26.7,69.44,25.274Z",
    transform: "translate(0 0.003)",
    fill: "url(#linear-gradient)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9859",
    "data-name": "Group 9859",
    transform: "translate(40.62 3.261)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9858",
    "data-name": "Group 9858"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3895",
    "data-name": "Path 3895",
    d: "M50.82,12.232h0l-.03-.07c-.04-.07-.08-.14-.11-.2L46.17,3.93l-4.51,8.022c-.04.07-.08.15-.12.22l-.03.06h0a5.076,5.076,0,0,0-.56,2.3,5.21,5.21,0,0,0,10.42,0A4.944,4.944,0,0,0,50.82,12.232Z",
    transform: "translate(-40.62 -3.26)",
    fill: "#00b7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3896",
    "data-name": "Path 3896",
    d: "M46.16,20a5.519,5.519,0,0,1-5.54-5.471,5.365,5.365,0,0,1,.38-1.98l.21-.48c.07-.13.12-.21.16-.29L46.16,3.26l4.8,8.542c.04.07.34.68.34.68a5.3,5.3,0,0,1,.4,2.041A5.508,5.508,0,0,1,46.16,20Zm-4.32-7.712-.04.09a4.682,4.682,0,0,0-.52,2.161,4.89,4.89,0,0,0,9.78,0,4.81,4.81,0,0,0-.52-2.161l-.05-.1a1.094,1.094,0,0,1-.08-.15L46.18,4.6l-4.22,7.512A.939.939,0,0,0,41.84,12.292Z",
    transform: "translate(-40.62 -3.26)",
    fill: "#231f20"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9861",
    "data-name": "Group 9861",
    transform: "translate(33.03 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9860",
    "data-name": "Group 9860"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3897",
    "data-name": "Path 3897",
    d: "M40.76,6.892h0s-.08-.15-.11-.2L37.27.67,33.89,6.692c-.03.05-.06.11-.09.17l-.03.04h0a3.895,3.895,0,1,0,7.4,1.73A3.606,3.606,0,0,0,40.76,6.892Z",
    transform: "translate(-33.03 0)",
    fill: "#00b7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3898",
    "data-name": "Path 3898",
    d: "M37.27,12.8a4.217,4.217,0,0,1-4.24-4.181,3.94,3.94,0,0,1,.25-1.4l.2-.48c.05-.1.09-.16.12-.22L37.27,0a.746.746,0,0,0,.07.12l.18.33c.09.17.19.33.28.5.12.21.24.42.35.64.14.24.27.49.41.73.15.26.29.53.44.79l.45.81c.15.27.3.53.44.8.14.25.28.5.41.75.12.22.24.44.36.65.14.24.27.49.41.73a3.728,3.728,0,0,1,.31.71,3.665,3.665,0,0,1,.13,1.04A4.234,4.234,0,0,1,37.27,12.8ZM34.1,6.962l-.04.07a3.5,3.5,0,0,0-.38,1.58,3.58,3.58,0,0,0,7.16,0,3.5,3.5,0,0,0-.38-1.58l-.1-.19L37.26,1.32,34.17,6.832C34.15,6.882,34.12,6.922,34.1,6.962Z",
    transform: "translate(-33.03 0)",
    fill: "#231f20"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9862",
    "data-name": "Group 9862",
    transform: "translate(0 5.641)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_12",
    "data-name": "Union 12",
    d: "M15.25,0A15.2,15.2,0,0,0,0,15.069a15.251,15.251,0,0,0,30.5,0A15.2,15.2,0,0,0,15.25,0Z",
    fill: "#fb2626"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3502",
    "data-name": "Group 3502",
    transform: "translate(12.708 5.023)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_966",
    "data-name": "Path 966",
    d: "M-.969,1.025H4.115L2.876,13.733H.286Z",
    transform: "translate(0.969 -1.025)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_975",
    "data-name": "Path 975",
    d: "M2.542,0A2.542,2.542,0,1,1,0,2.542,2.542,2.542,0,0,1,2.542,0Z",
    transform: "translate(0 15.25)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeakSensor);
export default __webpack_public_path__ + "static/media/leak_sensor.23a04acb3b1af24c3b9ba0805b95f0e5.svg";
export { ForwardRef as ReactComponent };